export const FREE_DOMAIN_FOR_1_YEAR = {
  translationKey: 'Advanced.Features_Vouchers_Free_Domain_for_1_Year',
  tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_Free_Domain_1_Year'
};
export const FREE_DOMAIN_UP_TO_3_YEARS = {
  translationKey: 'Advanced.Features_Vouchers_Free_Domain_for_up_to_3_years',
  tooltipTranslationKey: 'Advanced.Tooltips_Vouchers_Free_Domain_up_to_3_years'
};
export const CC_TLD_COUNTRIES = ['FR', 'BR', 'DE'];
export const COUNTRY_BE = 'BE';
const VOUCHER_ELIGIBLE_TLDS = new Set(['com', 'co.uk', 'net', 'org', 'art', 'be', 'biz', 'club', 'coach', 'fit', 'fitness', 'info', 'live', 'nl', 'online', 'pictures', 'rocks', 'space', 'shop', 'store', 'studio', 'training', 'xyz', 'yoga', 'fr', 'com.br', 'de']);
const getDomainTld = domainName => {
  if (!domainName) {
    return '';
  }
  const dotIndex = domainName.indexOf('.');
  return dotIndex !== -1 ? domainName.substring(dotIndex + 1) : '';
};
export const isEligibleForVoucher = domainName => {
  const tld = getDomainTld(domainName);
  return !!tld && VOUCHER_ELIGIBLE_TLDS.has(tld.toLowerCase());
};
export const getFreeDomainTooltipKey = _ref => {
  let {
    featureNameTranslationKey,
    geo,
    referralAdditionalInfo,
    domainName,
    isDisplayDomainExperimentEnabled,
    isMatchDomainCycleEnabled
  } = _ref;
  const isFreeDomainFeature = featureNameTranslationKey === FREE_DOMAIN_FOR_1_YEAR.translationKey || featureNameTranslationKey === FREE_DOMAIN_UP_TO_3_YEARS.translationKey;
  if (!isFreeDomainFeature) {
    return undefined;
  }
  const ccTldCountries = CC_TLD_COUNTRIES;
  const isCcTldCountry = geo && ccTldCountries.includes(geo.toUpperCase());
  const isBe = (geo == null ? void 0 : geo.toUpperCase()) === COUNTRY_BE;
  const shouldChangeKeys = Boolean(isDisplayDomainExperimentEnabled) && referralAdditionalInfo === 'add-domain-purchase-intent' && Boolean(domainName) && isEligibleForVoucher(domainName);
  if (shouldChangeKeys) {
    if (isCcTldCountry || isBe) {
      return isMatchDomainCycleEnabled ? 'Advanced.Tooltips_Vouchers_Free_Domain_up_to_3_years_ccTLD_new' : 'Advanced.Tooltips_Vouchers_Free_Domain_1_Year_ccTLD_new';
    }
    return isMatchDomainCycleEnabled ? 'Advanced.Tooltips_Free_Domain_personalization_up_to_3_years' : 'Advanced.Tooltips_Free_Domain_personalization_test';
  }
  const baseTooltipKey = isMatchDomainCycleEnabled ? FREE_DOMAIN_UP_TO_3_YEARS.tooltipTranslationKey : FREE_DOMAIN_FOR_1_YEAR.tooltipTranslationKey;
  return isCcTldCountry ? `${baseTooltipKey}_${geo.toLowerCase()}` : baseTooltipKey;
};
//# sourceMappingURL=freeDomainTooltipKey.js.map